
import React, { useEffect, useRef, useState } from 'react';
import { withStyles, Divider, Popover, Grid } from '@material-ui/core';
import { Typography } from 'components';
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import PropTypes from 'prop-types';

const styles = theme => ({
  dropdownRoot: {
    height: 25,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  textContainer: {
    width: '100%',
    height: 20,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  paper: {
    // border: '1px solid #FFFFFF',
    overflowY: 'hidden',
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
    padding: 10,
    borderRadius: 'unset'
  },
  text: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  red: {
    backgroundColor: '#de5151'
  },
  dashed: {
    backgroundColor: 'unset',
    borderBottom: '1px dashed #0000001f'
  },
  dropDownContainer: {
    borderRadius: 4,
    height: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  iconContainer: {
    width: 35,
    height: 35,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  inputContainer: {
    width: 'calc(100% - 20px)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '3px 0px'
  },
  elipsContainer: {
    borderRadius: 25,
    height: 'fit-content',
    cursor: 'pointer',
    padding: '5px 5px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center'
  },
  customContainer: {
    height: 'fit-content',
    cursor: 'pointer'
  },
  button: {
    marginTop: 5,
    marginRight: 10,
    backgroundColor: '#d7ecfe',
    padding: '3px 10px',
    display: 'flex',
    borderRadius: 25,
    width: 'fit-content',
    height: 'fit-content',
    alignItems: 'center'
  }
});

const DropDown = React.memo((props) => {
  const {
    classes,
    width = 200,
    type = 'line', // line, border, elips, custom
    fullWidth,
    placeholder,
    classNames,
    open,
    onClose,
    onOpen,
    value,
    children,
    error = false,
    disabled,
    custom = null,
    multipleValue = false,
    valueName = 'name',
    onRemoveItem
  } = props;
  const button = useRef(null)
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    setAnchorEl(ReactDOM.findDOMNode(button.current));
  }, [])

  return (
    <>
      <Grid container spacing={8}>
        <Grid item xs={12}>
          {type === 'line'
            ? <div
              className={classes.dropdownRoot}
              style={{ width: fullWidth ? '100%' : width }}
              onClick={onOpen}
              ref={button}
            >
              <div className={classes.textContainer}>
                {multipleValue
                  ? <Typography variant='body1' color='#bfbfbf'>
                    {placeholder || 'Select Item'}
                  </Typography>
                  : value
                    ? <Typography variant='body1' type='bold' className={classes.text}>{value}</Typography>
                    : <Typography variant='body1' color='#bfbfbf'>
                      {placeholder || 'Select Item'}
                    </Typography>
                }
                <FontAwesomeIcon color='#0073d1' icon='chevron-down' size='xs' style={{ margin: 5 }}/>
              </div>
              <Divider
                width='100%'
                height={2}
                classes={{
                  root: cx({
                    [classes.red]: error,
                    [classes.dashed]: disabled
                  })
                }}
              />
            </div>
            : type === 'filled'
              ? <div
                className={classes.dropDownContainer}
                style={{
                  width: fullWidth ? '100%' : width,
                  backgroundColor: '#e9e9e9',
                  height: 35
                }}
                onClick={onOpen}
                ref={button}
              >
                <div className={classes.inputContainer}>
                  {multipleValue
                    ? <Typography variant='body1' color='#bfbfbf'>
                      {placeholder || 'Select Item'}
                    </Typography>
                    : value
                      ? <Typography variant='body1' type='bold'>{value}</Typography>
                      : <Typography variant='body1' color='#bdb9b9' style={{ fontSize: 16 }}>{placeholder || 'Select Item'}</Typography>
                  }
                  <FontAwesomeIcon icon='chevron-down' size='sm' color='#969696' />
                </div>
              </div>
              : type === 'border'
                ? <div
                  className={classes.dropDownContainer}
                  style={{
                    width: fullWidth ? '100%' : width
                    // border: disabled ?  '1px dashed #0000001f' : '1px solid #969696',
                  }}
                  onClick={onOpen}
                  ref={button}
                >
                  {/* <div
                                className={classes.iconContainer}
                                style={{
                                    borderRight: disabled ?  '1px dashed #0000001f' : '1px solid #969696'
                                }}
                            >
                                <FontAwesomeIcon icon={icon ? icon : 'sticky-note'} size='sm' color='#969696' />
                                <img
                                    src='/api/static/icon/dropdown.png'
                                    width={15}
                                />
                            </div> */}
                  <div className={classes.inputContainer}>
                    {multipleValue
                      ? <Typography variant='body1' color='#bfbfbf'>
                        {placeholder || 'Select Item'}
                      </Typography>
                      : value
                        ? <Typography variant='body1' style={{ fontSize: 16 }}>{value}</Typography>
                        : <Typography variant='body1' color='#bdb9b9' style={{ fontSize: 16, color: 'rgb(166,166,166)' }}>{placeholder || 'Select Item'}</Typography>
                    }
                    <FontAwesomeIcon icon='chevron-down' size='sm' color='#969696' />
                  </div>
                </div>
                : type === 'elips'
                  ? <div
                    className={classes.elipsContainer}
                    style={{
                      width: fullWidth ? '100%' : width,
                      border: disabled ? '1px dashed #0000001f' : '1px solid #bfbfbf'
                    }}
                    onClick={onOpen}
                    ref={button}
                  >
                    {multipleValue
                      ? <Typography variant='body1' color='#bfbfbf'>
                        {placeholder || 'Select Item'}
                      </Typography>
                      : value
                        ? <Typography variant='body1' type='bold'>{value}</Typography>
                        : <Typography variant='body1' color='#bdb9b9'>{placeholder || 'Select Item'}</Typography>
                    }
                  </div>
                  : <div
                    style={{
                      cursor: 'pointer',
                      width: fullWidth ? '100%' : width
                    }}
                    onClick={onOpen}
                    ref={button}
                    className={classes.customContainer}
                  >
                    {custom}
                  </div>
          }
        </Grid>
        {multipleValue && value.length > 0 &&
                    <Grid item xs={12}>
                      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {value.map((item, key) =>
                          <div className={classes.button}>
                            <Typography variant='body1'>{item[valueName]}</Typography>
                            <FontAwesomeIcon
                              icon='times-circle'
                              color='#0073d1'
                              size='sm'
                              style={{ cursor: 'pointer', marginLeft: 5 }}
                              onClick={() => onRemoveItem(key)}
                            />
                          </div>
                        )}
                      </div>
                    </Grid>
        }
      </Grid>
      <Popover
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        classes={{
          paper: cx(
            classes.paper,
            classNames && classNames.paper
          )
        }}
        PaperProps={{
          style: {
            width: button.current && button.current.offsetWidth,
            minWidth: 180
          }
        }}
      >
        {children}
      </Popover>
    </>
  );
})

DropDown.propTypes = {
  classes: PropTypes.isRequired,
  children: PropTypes.any,
  classNames: PropTypes.object,
  // Jika lebar ditentukan maka akan menyesuaikan lebar yang tertera
  width: PropTypes.number,
  // Style bentuk dropdown
  type: PropTypes.oneOf(['line', 'border', 'elips', 'custom']),
  // Jika true maka lebar dropdown menyesuaikan komponen induk
  fullWidth: PropTypes.bool,
  // Pesan yang ditampilkan sebelum tanggal muncul atau ketika inputan kosong
  placeholder: PropTypes.string,
  // Jika true maka pilihan dropdown akan terbuka
  open: PropTypes.bool,
  // Fungsi yang dijalankan ketika tampilan pilihan tertutup
  onClose: PropTypes.func,
  // Fungsi yang dijalankan ketika tampilan pilihan terbuka
  onOpen: PropTypes.func,
  // Nilai yang ditampilkan pada saat pilihan telah terpilih
  value: PropTypes.string,
  // Tampilan error
  error: PropTypes.bool,
  // Dropdown tidak aktif
  disabled: PropTypes.bool,
  // Custon bentuk dropdown
  custom: PropTypes.any
}

export default (withStyles(styles)(DropDown));
